(function(angular, module) {var supportStaff;

supportStaff = function($http, ApiUrl, ModelService) {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'programs/initiatives/amcSupportStaff',
    scope: {
      program: '=',
      editable: '=',
      log: '='
    },
    link: function(scope) {
      var url;
      url = ApiUrl('ybusa_staff', 'search');
      scope.search = function(query) {
        return $http.get(url, {
          params: {
            q: query,
            department: ['americorps']
          }
        }).then(function(response) {
          return response.data.staff;
        });
      };
      return scope.save = function(data) {
        var ref, ref1;
        data = {
          portfolio_manager_id: ((ref = data.portfolio_manager) != null ? ref.id : void 0) || null,
          financial_manager_id: ((ref1 = data.financial_manager) != null ? ref1.id : void 0) || null
        };
        return ModelService.patch('program', scope.program.id, data);
      };
    }
  };
};

module.directive('amcSupportStaff', supportStaff);
})(angular, angular.module("dybProgramsInitiatives"));